var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAlert = function SvgAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#737373",
    d: "M38.486 26.4 25.009 5.12A6.12 6.12 0 0 0 20.006 2.5c-1.985 0-3.87.967-5.054 2.669L1.542 26.368C-.16 28.803-.476 31.72.708 33.973c1.168 2.252 3.62 3.536 6.688 3.536h25.219c3.085 0 5.52-1.284 6.688-3.536s.85-5.154-.817-7.572M18.338 12.508c0-.917.75-1.668 1.668-1.668s1.667.751 1.667 1.668v10.008c0 .917-.75 1.668-1.667 1.668-.918 0-1.668-.751-1.668-1.668zm1.668 20.015a2.5 2.5 0 0 1-2.502-2.502 2.5 2.5 0 0 1 2.502-2.502 2.5 2.5 0 0 1 2.501 2.502 2.5 2.5 0 0 1-2.501 2.502"
  })));
};
export default SvgAlert;